import React,{useState,useEffect,useRef} from "react";
import './classes/AppsByCountry.css';
import { configData } from "../config";
import Loading from './Loading';
import Select from 'react-dropdown-select';
import { Helmet } from 'react-helmet';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { DataGrid } from '@mui/x-data-grid';
 import { Link } from '@mui/material';
 import { format } from "date-fns";
import { Box, Pagination, PaginationItem } from '@mui/material';

const AttributionReport = ()=>{
     const initialForm = () => {
  const params = new URLSearchParams(window.location.search);

  const defaultForm = {
    start_date: '',
    start_date_obj: null,
    end_date: '',
    end_date_obj: null,
    view: '',
    action:''
  };

  //  normal dates
  const queryStart = params.get("start_date");
  const queryEnd = params.get("end_date");


  const startObj =
    queryStart
      ? new Date(queryStart.replace(/-/g, "/") + " 00:00:00")
      : null;

  const endObj =
    queryEnd
      ? new Date(queryEnd.replace(/-/g, "/") + " 00:00:00")
      : null;

  //  birthday dates
  const queryBdayStart = params.get("birthday_start_date");
  const queryBdayEnd = params.get("birthday_end_date");


  const queryView = params.get("view") || ''; 

  return {
    ...defaultForm,

    //  normal dates
    start_date: startObj ? queryStart : '',
    start_date_obj: startObj,

    end_date: endObj ? queryEnd : '',
    end_date_obj: endObj,


    view: queryView,
    action:''
  };
};       
      const [formData, setFormData] = useState(initialForm());
      const [appliedFormData, setAppliedFormData] = useState(initialForm());
      const [submittedData, setSubmittedData] = useState(null);
      const [isLoading, setIsLoading] = useState(true);
      const [countriesList, setCountriesList] = useState([]);
      const [statelist, setStateList] = useState({});

      const init = initialForm();  
  
       
   
      const [formErrors, setFormErrors] =useState({});
      const [isSubmitted, setIsSubmitted] = useState(false);

      
         const app_url = configData.APP_URL;
        const startDateRef = useRef(null);
       const endDateRef = useRef(null);
         
        useEffect(() => {
           Promise.all([
          ]).then(() => {
     
            setIsLoading(false);
          })
        }, []);
        
 
 
    const columns = [
  {
    field: 'first_name',
    headerName: 'First Name',      
    flex:1,
    sortable: false,
    // minWidth:140,
    cellClassName:'first_name_column',headerClassName:'first_name_header',
  },
  {
    field: 'last_name',
    headerName: 'Last Name',    
    flex:1,
    sortable: false,
    // minWidth:140,
    cellClassName:'last_name_column',headerClassName:'last_name_header',
  },
    {
    field: 'email',
    headerName: 'E-Mail',
    flex:1,
    sortable: false,
    // minWidth:220,
    cellClassName:'email_column',headerClassName:'email_header', 
     renderCell: (params) => (
    <Link href={params.row.url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
        {params.row.email}
      </Link>
  ),
    
  },
   {
    field: 'phone',
    headerName: 'Phone',    
    flex:1,
    sortable: false,
    // minWidth:140,
    cellClassName:'last_name_column',headerClassName:'last_name_header',
  },
  {
    field: 'country',
    headerName: 'Country',   
    flex:1,
    sortable: false,
    //  minWidth:150,
    cellClassName:'country_column',headerClassName:'country_header',
  },
  {
    field: 'salesperson',
    headerName: 'Salesperson',   
    flex:1,
    sortable: false,
    //  minWidth:150,
    cellClassName:'salesperson_column',headerClassName:'salesperson_header',
  },
  
   { field: 'created_at', headerName: 'Created date',sortable: false,cellClassName:'created_column',headerClassName:'created_header',minWidth:120, flex:1},
    { field: 'updated_at', headerName: 'Updated date',sortable: false,cellClassName:'updated_column',headerClassName:'updated_header',minWidth:120, flex:1},
    
   { field: 'rid', headerName: 'Roles',sortable: false,cellClassName:'roles_column',headerClassName:'roles_header',minWidth:170, flex:1},

];
const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({ pageSize: 50 });
  const [sortModel, setSortModel] = React.useState([]);
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

const handleDateChange = (date, field) => {
  setFormData(prev => ({
    ...prev,
    [`${field}_obj`]: date,                       // Date object for DatePicker
    [field]: date ? format(date, "yyyy-MM-dd") : '' // string for backend
  }));
};


  const validateDates = (formData) => {
    let errors = {};

    if (!formData.start_date) {
      errors.start_date = "Start date is required.";
    }

    if (!formData.end_date) {
      errors.end_date = "End date is required.";
    }

    if (formData.start_date && formData.end_date) {
      if (formData.end_date < formData.start_date) {
        errors.end_date = "Start date can't over end date.";
      }
    }

    return errors;
  };

    const [page, setPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(paginationModel.pageSize);
    const [totalItems, setTotalItems] = useState(0);
// Adjust the page controls
const totalPages = Math.ceil(totalItems / itemsPerPage);
const startIndex = (page - 1) * itemsPerPage;
const lastPageIndex = Math.min(startIndex + itemsPerPage, totalItems);

// Pagination controls
const goToNextPage = () => {
  setPage(prev => Math.min(prev + 1, totalPages));
};

const goToPrevPage = () => {
  setPage(prev => Math.max(prev - 1, 1));
};

const goToSpecificPage = (pageNumber) => {
  setPage(pageNumber);
};

function renderPaginationControls() {
  const maxButtons = 10;
  let startPage = Math.max(1, page - Math.floor(maxButtons / 2));
  let endPage = Math.min(totalPages, startPage + maxButtons - 1);

  if (endPage - startPage < maxButtons - 1) {
    startPage = Math.max(1, endPage - maxButtons + 1);
  }

  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);

  return (
    <div style={{marginTop: "16px"}}>
      {totalItems > itemsPerPage && (
        <div className="us-agent-pagination" style={{ textAlign: 'center' }}>
          {page > 1 && (
            <>
              <button onClick={() => setPage(1)} className="report-pagination">« First</button>
              <button onClick={goToPrevPage} className="report-pagination">‹ Previous</button>
            </>
          )}

          {pageNumbers.map(num => (
            <button
              key={num}
              onClick={() => goToSpecificPage(num)}
              style={{
                fontWeight: num === page ? 'bold' : 'normal',
                color: num === page ? '#fff' : '#111',
                background: num === page ? '#1976d2' : 'none',
                border: "none"
              }}
              className="report-pagination"
            >
              {num}
            </button>
          ))}

          {page < totalPages && (
            <>
              <button onClick={goToNextPage} className="report-pagination">Next ›</button>
              <button onClick={() => setPage(totalPages)} className="report-pagination">Last »</button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
   
      React.useEffect(() => {
        
   if(formData.start_date && formData.end_date) {
      const fetchData = async () => {
      // Simulate API call to your server
      // In a real application, replace this with your actual fetch logic
       try {
        setIsLoading(true);
      const response = await fetch(app_url+'attributionreport/getlist', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          page: page-1,
          pageSize: itemsPerPage,
          sortModel,
          filterModel,
          // formData:appliedFormData
          formData: {
            ...appliedFormData,
            action: isSubmitted ? 'submit' : ''
          }
        }),
      });
      const data = await response.json();
      console.log(data.data.rows);
      setRows(data.data.rows);
      setRowCount(data.data.totalRowCount); // Server should return totalRowCount
      setTotalItems(Number(data.data.totalRowCount));
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
            if (isSubmitted) {
              setIsSubmitted(false);
            }
          }
          
    };
    

    fetchData();
  }
      }, [ itemsPerPage, sortModel, filterModel, appliedFormData, page]); // Re-fetch data when these change 


useEffect(() => {
  setItemsPerPage(paginationModel.pageSize);
  setPage(1); // Reset to the first page whenever the pageSize changes
}, [paginationModel.pageSize]);    

const submitFormData = async (data) => {
  setSubmittedData(data);
  setAppliedFormData(data);
  setIsSubmitted(false);
  // try {
  //   setIsLoading(true);

  //   const response = await fetch(app_url + 'report/appsbycountry', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({
  //       page: 0,
  //       pageSize: 50,
  //       sortModel,
  //       filterModel,
  //       formData: data
  //     }),
  //   });

  //   const res = await response.json();

  //   setRows(res.data.rows);
  //   setRowCount(res.data.totalRowCount);
  // } catch (error) {
  //   console.error('Error fetching data:', error);
  // } finally {
  //   setIsLoading(false);
  // }
};

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault(); // stop page reload

    const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});
  
    // Reset pagination state
    setPaginationModel({ pageSize: 50 });
    setPage(1);
    setSubmittedData(formData);
    setAppliedFormData({...formData});
    setIsSubmitted(true);
    //  try {
    //     setIsLoading(true);
    //   const response = await fetch(app_url+'report/appsbycountry', {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({
    //        page: 0,
    //            pageSize: 50, 
    //       sortModel,
    //       filterModel,
    //       formData:formData
    //     }),
    //   });
    //   const data = await response.json();
    //   console.log(data.data.rows);
    //   setRows(data.data.rows);
    //   setRowCount(data.data.totalRowCount); // Server should return totalRowCount
    //   }  catch (error) {
    //         console.error('Error fetching data:', error);
    //       } finally {
    //         setIsLoading(false); // Set loading to false after fetch completes (success or error)
    //       }
    // console.log("Form submitted:", formData);


  };
  const handleExport = async (e) => {
    e.preventDefault(); // stop page reload

    const errors = validateDates(formData);

    if (Object.keys(errors).length > 0) {
      console.log("Validation errors:", errors);
      setFormErrors(errors); 
      return;
    }
    setFormErrors({});
   
     try {
        setIsLoading(true);
      const response = await fetch(app_url+'attributionreport/getexport', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          
          formData:formData
        }),
      });
      const data = await response.json();
     const csvUrl = data.data.csvUrl;
      const urlParts = csvUrl.split('/');
        const fileName = urlParts[urlParts.length - 1];
                const link = document.createElement('a');
                link.href = csvUrl;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
      
      }  catch (error) {
            console.error('Error fetching data:', error);
          } finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }


  };

useEffect(() => {
  const params = new URLSearchParams(window.location.search);

  if ([...params.keys()].length > 0) {
    const init = initialForm();

    setFormData(init);
    

    submitFormData(init);              
  }
}, []);

    return(
           <>
            {isLoading ? (
              <Loading />
            ) : (
        <div id="main" className="reports-main">
                <Helmet>
                    <title>
                        User's Attribution Details Report
                    </title>
                    
                </Helmet>
            <div className="left"></div>
            <div className="center left-center">
                <div className="apps-by-country-container">
                <h1>User's Attribution Details Report</h1>
                <p>User Attribution was created on 08/07/2026.</p>
                 <form onSubmit={handleSubmit}>
                  <p style={{fontWeight: "bold", fontSize: "1.1rem", color: "#111827"}}>Date of App:</p>
                <div className=''>
                    <label htmlFor="start_date">Start Date:</label>
                    <DatePicker
                      ref={startDateRef}
                      selected={formData.start_date_obj}
                     onChange={(date) => { handleDateChange(date, 'start_date');
                        
                      setTimeout(() => {
                                const input = startDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                    }}
                    id="start_date"
                    name="start_date" 
                    className=""
                    // required
                    />   
                  {formErrors.start_date && (
                    <div className="error">{formErrors.start_date}</div>
                  )}                 
                </div>
                <div className=''>
                    <label htmlFor="end_date">End Date:</label>
                    <DatePicker
                    ref={endDateRef}
                    selected={formData.end_date_obj}
                    onChange={(date) => { handleDateChange(date, 'end_date');
                       setTimeout(() => {
                                const input = endDateRef.current?.input;
                                if (input) {
                                  const len = input.value.length;
                                  input.setSelectionRange(len, len);
                                }
                              }, 0);
                    }}
                    id="end_date"
                    name="end_date"
                    className=""
                    // required
                    />  
                  {formErrors.end_date && (
                    <div className="error">{formErrors.end_date}</div>
                  )}                 
                </div>
                <div className="">
                          <input type="submit" value="Submit" className="form-submit"  />&nbsp; &nbsp;
                           <input type="button" value="Export" className="form-submit"  onClick={handleExport}/>&nbsp; &nbsp;
                           <a href="/admin/reports/apps_by_country"><input type="button" name="" value="Clear" class="form-submit" /></a>
                      </div>
                 </form>
                 {submittedData && (
                  <>
                 <div id="total_apps">Total Apps: {rowCount}</div>
                 
                 <div className="apps-by-country-course-date-table">
                                           <table className="">
                                                <div style={{ width: '100%' }}>
                                                <DataGrid
                                                rows={rows}
                                                columns={columns}
                                                rowCount={rowCount}
                                                paginationMode="server"
                                                sortingMode="server"
                                                filterMode="server"
                                                // paginationModel={paginationModel}
                                                // onPaginationModelChange={setPaginationModel}
                                                paginationModel={{ pageSize: paginationModel.pageSize }}
                                                onPaginationModelChange={(model) => setPaginationModel(model)}
                                                sortModel={sortModel}
                                                onSortModelChange={setSortModel}
                                                filterModel={filterModel}
                                                onFilterModelChange={setFilterModel}
                                                pageSizeOptions={[5, 10, 25,50]}
                                                getRowId={() => crypto.randomUUID()}
                                                getRowHeight={() => 'auto'}
                                                disableColumnFilter 
                                                //disableColumnResize={true}
                                            />
                                               </div>
                                            </table>
                                            </div>
                                            {renderPaginationControls()}
                                            </>
                  )} 
</div>
            </div>
            <div className="right">
                 
            </div>
        </div>
               )}
    </>
    );
};
export default AttributionReport;